import { AUTH_SUCCESS, AUTH_FAIL, SET_USER, AUTH_LOGOUT } from './../actions/auth';

const authReducer = (state, { type, payload }) => {
    state || (state = {
        auth: !!localStorage.getItem('effToken'),
        user: null,
        error: null,
    });

    let change = null;

    switch (type) {
        case AUTH_SUCCESS:
            change = {
                auth: true,
                user: null,
                error: null,
            }
            break;
        case AUTH_FAIL:
            change = {
                auth: false,
                user: null,
                error: payload,
            }
            break;
        case SET_USER:
            change = { user: payload, }
            break;
        case AUTH_LOGOUT:
            change = {
                auth: false,
                user: null,
                error: null,
            }
            break;
        default:
            change = {};
            break;
    }

    return { ...state, ...change }
}

export default authReducer;